module.exports = __webpack_public_path__ + "img/deco-gray.e09dcfe.png";